var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-dialog modal-lg" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v(_vm._s(_setup.modalTitle)),
        ]),
        _vm._v(" "),
        _c("button", {
          staticClass: "btn-close",
          attrs: { type: "button", "aria-label": "Close" },
          on: {
            click: function ($event) {
              return _vm.$emit("hide-modal")
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-body" },
        [
          _setup.formExists
            ? _c(_setup.Form, {
                attrs: { id: _setup.id, "form-id": _setup.formId },
              })
            : _c("div", { staticClass: "p-5 text-center" }, [
                _c("div", {
                  staticClass: "spinner-border text-secondary",
                  attrs: { role: "status" },
                }),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-footer d-flex justify-content-between" },
        [
          _c("div", [
            _setup.id
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-danger",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _setup.deleteItem.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "bi-trash3 me-1" }),
                    _vm._v(" Delete\n                "),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _setup.formExists
            ? _c(_setup.FormSaveBtn, { attrs: { "form-id": _setup.formId } })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }